import { Component, Input, OnInit } from '@angular/core';
import { SPINNER_DEFAULT_SETTINGS } from '../../constants';
import { Subscription } from 'rxjs';
import { Spinner } from '../../models/spinner';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnInit {
  @Input() overlayClass: string;
  @Input() fullScreen: boolean;
  @Input() name: string;
  @Input() gif: string;
  spinner: Spinner = new Spinner();
  show: boolean;
  subscription: Subscription;

  constructor(private spinnerService: SpinnerService) {
    this.fullScreen = true;
    this.name = SPINNER_DEFAULT_SETTINGS.SPINNER_NAME;
    this.gif = SPINNER_DEFAULT_SETTINGS.SPINNER_GIF;
    this.show = false;
  }

  ngOnInit() {
    this.spinner = new Spinner({
      name: this.name,
      class: this.overlayClass,
      fullScreen: this.fullScreen,
      gif: this.gif,
      show: this.show,
    });
    this.spinnerService.getSpinner(this.name).subscribe((spinner: Spinner) => {
      if (spinner.name === this.spinner.name) {
        this.spinner.show = spinner.show;
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
